import React from 'react';
import { motion } from 'framer-motion';
import { MonitorPlay, BookOpen, Layout, Briefcase, PenTool, Share2, Mail } from 'lucide-react';
const services = [{
  icon: <MonitorPlay size={28} strokeWidth={1.5} data-id="element-150" />,
  title: 'Presentation Design',
  description: 'Pitch decks, keynote presentations, and sales materials that tell a compelling story and drive action.'
}, {
  icon: <BookOpen size={28} strokeWidth={1.5} data-id="element-151" />,
  title: 'Brochures & Print',
  description: 'Editorial design, lookbooks, and multi-page layouts crafted with rigorous attention to typography and grid.'
}, {
  icon: <Layout size={28} strokeWidth={1.5} data-id="element-152" />,
  title: 'Website Design',
  description: 'Bespoke digital experiences that blend aesthetic beauty with intuitive user experience.'
}, {
  icon: <PenTool size={28} strokeWidth={1.5} data-id="element-153" />,
  title: 'Brand Identity',
  description: 'Logos, color palettes, typography systems, and brand guidelines that establish a strong market presence.'
}, {
  icon: <Briefcase size={28} strokeWidth={1.5} data-id="element-154" />,
  title: 'Business Cards',
  description: 'Premium stationery and business cards that leave a lasting physical impression.'
}, {
  icon: <Share2 size={28} strokeWidth={1.5} data-id="element-155" />,
  title: 'Marketing Collateral',
  description: 'Social media templates, digital ads, and promotional graphics aligned with your core brand.'
}, {
  icon: <Mail size={28} strokeWidth={1.5} data-id="element-156" />,
  title: 'Email Marketing',
  description: 'Branded email templates and campaign designs that boost engagement and convert subscribers into customers.'
}];
export function Services() {
  return <section id="services" className="py-24 md:py-32 bg-ink text-cream" data-id="element-157">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-158">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24" data-id="element-159">
          <div className="lg:col-span-4" data-id="element-160">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="sticky top-32" data-id="element-161">
              <h2 className="text-5xl md:text-7xl font-serif tracking-tight mb-6" data-id="element-162">
                Core <br data-id="element-163" />
                <span className="italic text-cream/70" data-id="element-164">Expertise</span>
              </h2>
              <p className="text-cream/70 mb-8 max-w-sm" data-id="element-165">
                I partner with ambitious brands to create cohesive visual
                systems across digital and physical touchpoints.
              </p>
              <a href="#contact" className="inline-flex items-center gap-2 text-accent hover:text-white transition-colors font-medium" data-id="element-166">
                Discuss a project
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-167">
                  <path d="M3.33331 8H12.6666M12.6666 8L8 3.33331M12.6666 8L8 12.6666" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-168" />
                </svg>
              </a>
            </motion.div>
          </div>

          <div className="lg:col-span-8" data-id="element-169">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-12" data-id="element-170">
              {services.map((service, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className="border-t border-cream/20 pt-6" data-id="element-171">
                  <div className="text-accent mb-6" data-id="element-172">{service.icon}</div>
                  <h3 className="text-2xl font-serif mb-3" data-id="element-173">{service.title}</h3>
                  <p className="text-cream/60 text-sm leading-relaxed" data-id="element-174">
                    {service.description}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}